// ╔══════════════════════════════════════════════════════════════╗
// ║  Formatting helpers — Arabic locale                            ║
// ╚══════════════════════════════════════════════════════════════╝

export const fmtAR = (n) =>
  Number(n ?? 0).toLocaleString('ar-EG', { maximumFractionDigits: 0 });

export const fmtEGP = (n) => fmtAR(n);

export const fmtMoney = (n) => `${fmtAR(n)} جنيه`;

export const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('ar-EG', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
};

export const fmtDateShort = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('ar-EG');
};

export const fmtRelativeTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const min = Math.floor(diffMs / 60_000);
  if (min < 1) return 'الآن';
  if (min < 60) return `منذ ${min} د`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `منذ ${hr} س`;
  const day = Math.floor(hr / 24);
  if (day < 7) return `منذ ${day} يوم`;
  return fmtDateShort(iso);
};

export const ROLE_LABEL_AR = {
  admin: 'مدير عام',
  acc: 'محاسب',
  eng: 'مدير الهندسة',
};

export const STATUS_LABEL_AR = {
  active: 'نشط',
  leave: 'إجازة',
  probation: 'تحت التجربة',
  terminated: 'منتهية الخدمة',
  pending: 'قيد المراجعة',
  approved: 'معتمد',
  rejected: 'مرفوض',
  completed: 'مكتمل',
  draft: 'مسودة',
  calculated: 'محسوب',
  paid: 'تم الصرف',
};
